
<div>
  <b-modal
    id="modale-confirmation-ci-cl"
    content-class="modal-bingo-confirm-ci-cl"
    body-class="py-0"
    centered
    hide-header-close
    no-fade
    no-hide-backdrop
    no-close-on-backdrop
    no-close-on-esc
  >
    <div class="body-4 texte-noir text-left px-2 py-1" v-html="texteModale" />
    <template #modal-footer>
      <b-row class="row col-12 justify-content-center">
        <b-button
          class="btn btn-primaire w-xs-auto w-md-auto px-4"
          variant="modal"
          @click="redirectValidationIdentite()"
          >{{ $t('messageComponent.continuer') }}</b-button
        >
        <b-button
          class="btn btn-secondaire w-xs-auto w-md-auto px-4"
          variant="modal"
          @click="fermerModale()"
          >{{ $t('messageComponent.annuler') }}</b-button
        >
      </b-row>
    </template>
  </b-modal>
</div>
